import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  .search-wrapper {
    display: flex;
    /* align-items: center; */
    /* flex-direction: row; */
  }
  margin: 24px 32px;
  /* padding: 0 12px; */

  .left {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .button-group {
    height: 100%;
    margin-left: 64px;
    display: flex;
    /* flex-direction: column;
    justify-content: space-between;
    align-items: center; */
    .reset {
      /* margin-bottom: 24px; */
      margin-right: 24px;
    }
    .search {
      margin-right: 0;
    }
  }
  .first-line {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    > div {
      width: 33.33%;
      margin-right: 48px;
    }
  }

  .single-select {
    /* width: 400px; */
    /* height: 56px; */
  }

  .MuiTextField-root {
    /* width: 400px; */
    /* height: 56px; */
  }
`;
export default SearchGroupStyled;
